import { render, staticRenderFns } from "./GovernanceInnoInfoWin.vue?vue&type=template&id=6e81bc9e&"
import script from "./GovernanceInnoInfoWin.vue?vue&type=script&lang=js&"
export * from "./GovernanceInnoInfoWin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports